import React, {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import { addToCart, removeFromCart } from '../actions/cartActions'
// import {Image} from '@material-ui/icons';
import {Image} from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import { makeStyles  } from '@mui/styles';
import {CardMedia,
  IconButton ,
  Card,
  CardHeader,
  CardActions,
  Typography,
  CardContent ,
    Button,
    Box,
    List,
    ListItemAvatar,
    Avatar,
    Divider,
    ListItemText ,
    Grid,
    TextField,
    Select,
    MenuItem,
    ListItem,
    FormControl } from '@mui/material'
    import { createTheme, ThemeProvider } from '@mui/material/styles';
    import DeleteIcon from '@mui/icons-material/Delete';
    import MoreVertIcon from '@mui/icons-material/MoreVert';



    const theme = createTheme();

    const useStyles = makeStyles((theme) => ({
        root: {
          width: '100%',
          maxWidth: 360,
          // backgroundColor: theme.palette.background.paper,
        },
      }));

const CartScreen = ({match, location, history }) => {

    const productId = match.params.id

    const qty = location.search ? Number(location.search.split('=')[1]) : 1
  
    const dispatch = useDispatch()

    const cart = useSelector((state) => state.cart)
    const { cartItems } = cart

    const [qty_a, setQty] = useState(0)


    useEffect(() => {
        if (productId) {
          dispatch(addToCart(productId, qty))
        }
      }, [dispatch, productId, qty])

      const removeFromCartHandler = (id) => {
        dispatch(removeFromCart(id))
      }

      const checkoutHandler = () => {
        // history.push('/login?redirect=shipping')
        console.log('ceckout')
      }


      const classes = useStyles();

      
    return (
        <Grid container spacing={2} >
            <Grid item xs={8}>
                <h1>Shopping Cart</h1>
                {cartItems.length === 0 ? (
                // <Message>
                //     Your cart is empty <Link to='/'>Go Back</Link>
                // </Message>
                        <Alert severity="info" variant="filled">Empty</Alert>
                ) : (
                    //  <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                   <Grid spacing={2}>
                        {cartItems.map((item) => (
                          <Card sx={{ display: 'flex',mt:1 }} >
                            <CardMedia
                              component="img"
                              sx={{ maxWidth :180,maxHeight:180}}
                              image={'/images/'+item.image} 
                              alt={item.name}
                            />
                            <Box sx={{ width:'100%',display: 'flex' , flexDirection: 'column'}}>
                            <CardContent sx={{ flex: '1 0 auto' }}>
                              <Typography component="div" color="text.secondary" >
                              {item.name}
                              </Typography>
                              <Divider orientation="horizontal" />
                              <Typography color="text.primary" component="div" sx={{ mt:2 }} >
                              Rp.{item.price}
                              </Typography>
                              <Divider orientation="horizontal"  />
                              <Box sx={{width:'100%', display: 'flex',alignSelf: 'flex-end', alignItems: 'flex-end', pl: 1, pb: 1 }}>
                             
                                <Grid xs={9}>

                                </Grid>
                                <Grid xs={3}>
                                <FormControl sx={{ mt:2}}>
                                  <TextField
                                          id="fullWidth"
                                          label="JUMLAH"
                                          type="number"
                                          variant="standard"
                                          value={item.qty}
                                          InputLabelProps={{
                                              shrink: true,
                                          }}
                                          InputProps={{ inputProps: { min: 1, max: item.countInStock} }}
                                          onChange ={(e) => {

                                              var value = Number(e.target.value);
                                              if (value > item.countInStock) value = item.countInStock;
                                              if (value < 1) value = 1;
                                              dispatch(
                                                addToCart(item.product, Number(value))
                                              )
                                          }}

                                      />

                                </FormControl>

                                  <IconButton sx={{ mt:2}} aria-label="Delete" onClick={() => removeFromCartHandler(item.product)}>
                                  {/* {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />} */}
                                    <DeleteIcon sx={{ height: 30, width: 30 }} />
                                  </IconButton>

                                </Grid>
                              
                              </Box>

                              
                            </CardContent>
                            </Box>
                            <CardActions>
                            
                            </CardActions>

                          </Card>

//                             <ListItem>
//                             <ListItemAvatar>
//                             {/* <Avatar>
//                                 <Image /> 
//                                 <Image src={'/images/'+item.image} alt={item.name} fluid rounded />
//                             </Avatar> */}
//                             <Avatar alt={item.name} src={'/images/'+item.image} />
//                             </ListItemAvatar>
//                             <ListItemText primary={item.name} secondary="Jan 9, 2014" />
//                             <ListItemText primary={`Rp,`+item.price} secondary="Jan 9, 2014" />
//                             <FormControl>

//                             <TextField
//                                         id="outlined-number"
//                                         label="Jumlah"
//                                         type="number"
//                                         value={item.qty}
//                                         InputLabelProps={{
//                                             shrink: true,
//                                         }}
//                                         InputProps={{ inputProps: { min: 0, max: item.countInStock} }}
//                                         onChange ={(e) => {

//                                             var value = Number(e.target.value);
//                                             if (value > item.countInStock) value = item.countInStock;
//                                             if (value < 1) value = 1;
//                                             // setQty(value)
//                                             dispatch(
//                                               addToCart(item.product, Number(value))
//                                             )
//                                         }}

//                                     />
// {/*                                     
//                                     <Select
//                                     value={item.qty}
//                                     onChange={(e) =>
//                                         dispatch(
//                                           addToCart(item.product, Number(e.target.value))
//                                         )
//                                       }
//                                     displayEmpty
//                                     //   className={classes.selectEmpty}
//                                     inputProps={{ 'aria-label': 'Without label' }}
//                                     >
//                                         {[...Array(item.countInStock).keys()].map(
//                                                         (x) => (
//                                                             <MenuItem  key={x + 1} value={x + 1}>
//                                                             {x + 1}
//                                                             </MenuItem >
//                                                         )
//                                                         )}
                                                    
//                                     </Select> */}
//                                 </FormControl>
                                
//                                 <Button variant="contained" color="secondary" 
//                                  onClick={() => removeFromCartHandler(item.product)}
//                                >Delete
//                                 </Button>
//                             </ListItem>
                        
                        
                         ) )}

                  
                      </Grid>
                  // </List>
          
                )}

            </Grid>
            <Grid item xs={4} >
              <Card >
                <CardContent>
                  
                  <Typography gutterBottom variant="h5" component="h2">
                    
                  Subtotal ({cartItems.reduce((acc, item) => acc + item.qty, 0)})
                  items
                  
                  </Typography>
                  <Divider orientation="horizontal"  />
              
                  <Typography variant="h5" color="textPrimary" component="h4">
                  Rp. {cartItems
                      .reduce((acc, item) => acc + item.qty * item.price, 0)
                      .toFixed(2)}
                  </Typography>
                  <Divider orientation="horizontal"  />
                  <Button sx={{ mt:2}} variant="contained" color="primary" 
                    disabled={cartItems.length === 0}
                    onClick={checkoutHandler}
                  >
                Proceed To Checkout
              </Button>


                </CardContent>
                
              </Card>

                
            </Grid>

        </Grid>
    )
}

export default CartScreen
